const autocompleteFormEquip = {
  local: 'Local',
  equipment: 'Equipamento',
  area: 'Departamento',
  company: 'Empresas Terceiras',
  equipInfo: 'Detalhes do Equip.',
  equipmentAttachments: 'Anexos do Equipmento',
  equipmentModelAttachments: 'Anexos do Tipo de Equipamento',
  noAttachments: 'Nenhum anexo disponível',
};

export default autocompleteFormEquip;
